import type { ColumnsType } from 'antd/lib/table'
import { FootPrintType } from '../models/footprint.model'
import {
  FormLabels,
  CustomDateColumn,
  CustomHeaderText,
  CustomTextColumn,
  FootPrintListActionColumn,
  FootprintMovileViewColumn,
} from 'src/components'

const footPrintColumns: ColumnsType<FootPrintType> = [
  {
    title: () => <CustomHeaderText text={'footPrint.Name'} />,
    sorter: (a, b) => a.name.length - b.name.length,
    responsive: ['sm'],
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => <div style={{ marginTop: '10px' }}>
      <span style={{ textAlign: 'center' }}>
        {record.name}
      </span>
    </div>
  },
  {
    title: () => <CustomHeaderText text={'footPrint.TypeDesc'} />,
    responsive: ['sm'],
    sorter: (a, b) => a.footprint_type.name.length - b.footprint_type.name.length,
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => <div style={{ marginBottom: '-10px' }}>
      <FormLabels title={record.footprint_type.name} subtitle={record.description} />
    </div>
  },
  {
    title: () => <CustomHeaderText text={'footPrint.CO2Amount'} isCentered />,
    responsive: ['sm'],
    sorter: (a, b) => a.co2_amount - b.co2_amount,
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => {
      const value = record.co2_amount
      return <div style={{ marginBottom: '-10px' }}>
        <CustomTextColumn text={`${value} tCO₂`} />
      </div>
    },
  },
  {
    title: () => <CustomHeaderText text={'admin.CertificateDate'} isCentered />,
    responsive: ['sm'],
    sorter: (a, b) => {
      const dateA = new Date(a.date_of_footprint)
      const dateB = new Date(b.date_of_footprint)
      return dateA.getTime() - dateB.getTime()
    },
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => <CustomDateColumn dateValue={record.date_of_footprint} />,
  },
  {
    title: () => <CustomHeaderText text={'general.Actions'} isCentered />,
    responsive: ['sm'],
    render: (_, record) => <FootPrintListActionColumn footprint={record} />,
  },

  // Mobile View
  {
    title: () => <CustomHeaderText text='menuItems.FootPrint' isCentered />,
    responsive: ['xs'],
    sorter: (a: FootPrintType, b: FootPrintType) => {
      const dateA = new Date(a.date_of_footprint)
      const dateB = new Date(b.date_of_footprint)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, footprint) => <FootprintMovileViewColumn footprint={footprint} />
  },
]

export default footPrintColumns
